export const REQUIRED_APP_VERSION = '2.9.8';
export const APP_UPDATE_NOTICE_STORAGE_KEY = 'app_update_notice_2_9_8';

export const EASYEAT_PARTNER_ANDROID_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.partner.easyeat';
export const EASYEAT_PARTNER_IOS_STORE_URL =
  'https://apps.apple.com/app/easyeat-partner/id1519728811';

export function compareAppVersions(current: string, required: string): number {
  const currentParts = String(current || '')
    .split('.')
    .map((part) => parseInt(part, 10) || 0);
  const requiredParts = String(required || '')
    .split('.')
    .map((part) => parseInt(part, 10) || 0);
  const length = Math.max(currentParts.length, requiredParts.length);

  for (let i = 0; i < length; i++) {
    const diff = (currentParts[i] || 0) - (requiredParts[i] || 0);
    if (diff !== 0) {
      return diff > 0 ? 1 : -1;
    }
  }
  return 0;
}

export function isAppVersionBelowRequired(
  current: string,
  required: string = REQUIRED_APP_VERSION
): boolean {
  if (!current) {
    return true;
  }
  return compareAppVersions(current, required) < 0;
}

export function isIosDevice(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent || '';
  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return true;
  }

  // iPadOS can report as Macintosh with touch support.
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}

export function isReactNativeWebView(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    return (
      localStorage.getItem('is_react') === '1' ||
      !!(window as any).ReactNativeWebView
    );
  } catch {
    return !!(window as any).ReactNativeWebView;
  }
}

export function isIosPartnerApp(): boolean {
  return isReactNativeWebView() && isIosDevice();
}
